@if (!hideTimeline()) {
    <ca-flow-timeline [timelinePreview]="true" />
}
<div class="flow" [class.no-timeline]="hideTimeline()" caResizeObserver>
    <!-- START: Main Block Container -->
    @let containerBlocks = service.getContainerBlocks() | markDoneBlocks: service.currentContainerBlockId;
    @for (block of containerBlocks; track block.id; let index = $index; let isFirstContainer = $first; let isLastContainer = $last) {
        @if (!service.hiddenContainers[block.id]) {
            <div
                class="block-container"
                [class.done]="block.done"
                [class.active]="block.id === service.currentContainerBlockId"
                [class.last]="isLastContainer"
            >
                <div [attr.data-testid]="'block-container-' + block.id" class="block-container-title" (click)="service.onContainer(block)">
                    <div class="block-title-index">
                        @if (block.done) {
                            <mat-icon class="block-done-icon">check</mat-icon>
                        } @else {
                            {{ index + 1 }}
                        }
                    </div>
                    @if (block.titleKey | translationKey: block.titleData; as title) {
                        <div>{{ title | blockId: block.id : devMode() }}</div>
                    }
                </div>
                @if (block.headerKey; as header) {
                    <div class="sm:ms-12 ca-text-md">
                        {{ header | translationKey: block.headerData }}
                    </div>
                }

                <!-- START: Accordion Block Container -->
                @if (service.currentAccordionBlockId; as currentAccordionBlockId) {
                    <div class="block-accordions">
                        @let accordionBlocks = service.getAccordionBlocks(block) | markDoneBlocks: currentAccordionBlockId;
                        @for (
                            accordionBlock of accordionBlocks;
                            track accordionBlock.id;
                            let accordionIndex = $index;
                            let isFirstAccordion = $first;
                            let isLastAccordion = $last
                        ) {
                            @if (!service.hiddenAccordions[accordionBlock.id]) {
                                <div
                                    class="block-accordion"
                                    [class.virtual-accordion]="accordionBlock.isVirtual"
                                    [class.active]="accordionBlock.id === currentAccordionBlockId"
                                    caForm
                                    #formTools="formTools"
                                >
                                    @if (!accordionBlock.isVirtual) {
                                        <div
                                            [attr.data-testid]="'block-accordion-' + accordionBlock.id"
                                            class="block-accordion-header"
                                            [class.active]="accordionBlock.id === currentAccordionBlockId"
                                            (click)="service.onAccordion(accordionBlock)"
                                        >
                                            @if (accordionBlock.titleKey | translationKey: accordionBlock.titleData; as accordionTitle) {
                                                <div class="block-accordion-title">
                                                    {{ accordionTitle | blockId: accordionBlock.id : devMode() }}
                                                </div>
                                            }
                                            <div class="block-accordion-header-actions">
                                                @if (accordionBlock.id === currentAccordionBlockId) {
                                                    <!-- TODO: Hide this with "hidden" class until we know how to show it -->
                                                    <span class="block-accordion-count hidden"
                                                        >{{ accordionIndex + 1 }}/{{ accordionBlocks.length }}</span
                                                    >
                                                    <mat-icon>expand_less</mat-icon>
                                                } @else {
                                                    @if (accordionBlock.done || block.done) {
                                                        <!-- TODO: Hide this with "hidden" class until we know how to show it -->
                                                        <mat-icon class="accordion-done-icon hidden">check</mat-icon>
                                                    }
                                                    <mat-icon>expand_more</mat-icon>
                                                }
                                            </div>
                                        </div>
                                        @if (accordionBlock.headerKey; as accordionHeader) {
                                            <div class="sm:px-6 mb-6 ca-text-md">
                                                {{ accordionHeader | translationKey: accordionBlock.headerData }}
                                            </div>
                                        }
                                    }
                                    @if (accordionBlock.id === currentAccordionBlockId) {
                                        <div class="block-questions">
                                            <!-- START: Question Block Container -->

                                            @let questionBlocks = service.getQuestionBlocks(accordionBlock);
                                            @for (questionBlock of questionBlocks | visibleQuestionBlocks; track questionBlock.id) {
                                                <div>
                                                    @if (questionBlock.titleKey; as titleKey) {
                                                        <div class="question-title mt-4 mb-3">
                                                            {{
                                                                titleKey
                                                                    | translationKey: questionBlock.titleData
                                                                    | blockId: questionBlock.id : devMode()
                                                                    | requiredMarker: questionBlock.template?.slots
                                                            }}
                                                        </div>
                                                    }
                                                    @if (questionBlock.headerKey; as headerKey) {
                                                        <div class="question-header">
                                                            {{
                                                                headerKey
                                                                    | translationKey: questionBlock.headerData
                                                                    | blockId: questionBlock.id : devMode()
                                                                    | requiredMarker: questionBlock.template?.slots
                                                            }}
                                                        </div>
                                                    }
                                                    @switch (questionBlock.template?.type) {
                                                        @case (templateType.SingleSlotQuestionTemplate) {
                                                            <div class="question-slots" [caLayout]="questionBlock.template?.layout">
                                                                <!-- START: Template Slot -->
                                                                @for (
                                                                    slot of questionBlock.template?.slots;
                                                                    track slot;
                                                                    let slotIndex = $index
                                                                ) {
                                                                    <ca-template-slot
                                                                        [slot]="slot"
                                                                        [form]="formTools.form"
                                                                        [slotIndex]="slotIndex"
                                                                        [questionBlockValidations]="
                                                                            questionBlock.validations | targetSlotValidations: slot.id
                                                                        "
                                                                        [questionBlockId]="questionBlock.id"
                                                                        [devMode]="devMode()"
                                                                        [value]="service.getNestedValue(slot)"
                                                                        (valueChange)="
                                                                            service.recalculateContextModel(questionBlocks, slot, $event);
                                                                            service.onQuestionValueChange(
                                                                                accordionBlock,
                                                                                questionBlock,
                                                                                $event
                                                                            )
                                                                        "
                                                                    ></ca-template-slot>
                                                                }
                                                                <!-- END: Template Slot -->
                                                            </div>
                                                        }
                                                        @case (templateType.MultiSlotQuestionTemplate) {
                                                            <div class="question-slots" [caLayout]="questionBlock.template?.layout">
                                                                <!-- START: Template Slot -->
                                                                @for (
                                                                    slot of questionBlock.template?.slots;
                                                                    track slot;
                                                                    let slotIndex = $index
                                                                ) {
                                                                    <ca-template-slot
                                                                        [slot]="slot"
                                                                        [slotIndex]="slotIndex"
                                                                        [form]="formTools.form"
                                                                        [questionBlockValidations]="
                                                                            questionBlock.validations | targetSlotValidations: slot.id
                                                                        "
                                                                        [questionBlockId]="questionBlock.id"
                                                                        [devMode]="devMode()"
                                                                        [value]="service.getNestedValue(slot)"
                                                                        (valueChange)="
                                                                            service.recalculateContextModel(questionBlocks, slot, $event);
                                                                            service.onQuestionValueChange(
                                                                                accordionBlock,
                                                                                questionBlock,
                                                                                $event
                                                                            )
                                                                        "
                                                                    ></ca-template-slot>
                                                                }
                                                                <!-- END: Template Slot -->
                                                            </div>
                                                        }
                                                    }
                                                    @if (
                                                        getQuestionBlockValidationError(questionBlock.validations);
                                                        as questionBlockError
                                                    ) {
                                                        <ca-form-error-message class="question-block-error">
                                                            {{
                                                                questionBlockError.errorMessageKey
                                                                    | translationKey: questionBlockError.errorMessageData
                                                            }}
                                                        </ca-form-error-message>
                                                    }
                                                    @if (questionBlock.footerKey; as footerKey) {
                                                        <div class="question-footer sm:px-6">
                                                            {{ footerKey | translationKey: questionBlock.footerData }}
                                                        </div>
                                                    }
                                                </div>
                                            }
                                            <!-- END: Question Block Container -->
                                        </div>

                                        @if (accordionBlock.footerKey; as accordionFooter) {
                                            <div class="sm:px-6 py-3 ca-text-md">
                                                {{ accordionFooter | translationKey: accordionBlock.footerData }}
                                            </div>
                                        }
                                        @if (!hideActionButtons()) {
                                            <div class="block-actions">
                                                @if (!isFirstContainer || !isFirstAccordion) {
                                                    <button
                                                        data-testid="block-back-btn"
                                                        mat-stroked-button
                                                        class="block-btn ca-button"
                                                        (click)="back(formTools.form, accordionBlock)"
                                                    >
                                                        {{ 'BUTTON.BACK' | translate }}
                                                    </button>
                                                }
                                                @if (!isLastContainer || !isLastAccordion) {
                                                    <button
                                                        data-testid="block-next-btn"
                                                        mat-flat-button
                                                        class="block-btn ca-button"
                                                        (click)="next(formTools.form, accordionBlock)"
                                                    >
                                                        {{ 'BUTTON.NEXT' | translate }}
                                                    </button>
                                                } @else {
                                                    <button
                                                        data-testid="block-show-results-btn"
                                                        mat-flat-button
                                                        class="ca-button"
                                                        (click)="finalize(formTools.form, accordionBlock)"
                                                    >
                                                        {{ 'BUTTON.SHOW_RESULTS' | translate }}
                                                    </button>
                                                }
                                            </div>
                                        }
                                    }
                                </div>
                            }
                        }
                    </div>
                }
                <!-- END: Accordion Block Container -->

                @if (block.footerKey; as footer) {
                    <div class="sm:ms-12 ca-text-md">
                        {{ footer | translationKey: block.footerData }}
                    </div>
                }
            </div>
        }
    }
    <!-- START: Main Block Container -->
</div>
